window.sendinblue = {};
for (
  var j = ["track", "identify", "trackLink", "page"], i = 0;
  i < j.length;
  i++
) {
  (function (k) {
    window.sendinblue[k] = function () {};
  })(j[i]);
}
